import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Task error |||| Task errors',
    }
  }
}